<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Notificações
    </h1>
</header>
<main class="col-12 main__content">
    <header class="content__header">
        <h3>Notificações</h3>
        <filtro-dados [pageItens]="5" [totalItens]="notificacoes.length"
            (changeQuantidade)="onChangeQuantidadeItens($event)" *ngIf="notificacoes && notificacoes.length > 0">
        </filtro-dados>
    </header>

    <ng-container #showLoading>
        <spinner [show]="loading"></spinner>
    </ng-container>

    <ng-template #naoPossuiNotificacoes>
        <ng-container *ngIf="!loading">
            <section class="ngTemplateNaoPossui">
                <p>Você não possui Notificações!</p>
            </section>
        </ng-container>

    </ng-template>
    <section *ngIf="notificacoes && notificacoes.length > 0 else naoPossuiNotificacoes">
        <div class="d-flex content__header__table">
            <div class="col-xl-4">Tipo</div>
            <div class="col-xl-5">Situação</div>
            <div class="col-xl-3">Ações</div>
        </div>
        <div class="table__card" *ngFor="let notificacao of getItensDaPagina()">
            <div class="col-xl-4">{{notificacao.tipo}}</div>
            <div class="col-xl-5">{{notificacao.situacao}}</div>
            <div class="col-xl-3 table__card__button__action" (click)=redirecionar(notificacao.pathLink)>
                <fa-icon [icon]="faArrowRight"></fa-icon>
            </div>
        </div>
    </section>
</main>
<footer class="col-12 footer__content" *ngIf="notificacoes && notificacoes.length > 0">
    <ngb-pagination [collectionSize]="notificacoes.length" [(page)]="paginaAtual" [pageSize]="itensPorPagina"
        [maxSize]="2"></ngb-pagination>
</footer>